import { observer } from 'mobx-react';
import cls from 'classnames';

import Icon from '../Icon/Icon';
import Link, { NAV } from '../Link/Link';

import styles from './DocumentationLink.module.css';

interface DocumentationLinkProps {
  href: string;
  iconOnly?: boolean;
  className?: string;
}

function DocumentationLink(props: DocumentationLinkProps) {
  const { href, className, iconOnly = false } = props;

  return (
    <Link aria-label="Help" className={styles.documentationLink} href={href} external appearance={NAV}>
      <Icon className={cls(styles.documentationLinkIcon, className)} name="help" />

      <span>{!iconOnly && 'Help'}</span>
    </Link>
  );
}

export default observer(DocumentationLink);
